import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class Breadcrumb extends Component {
  constructor(props){
    super(props);

    this.setCrumbs = this.setCrumbs.bind(this);
  }

  setCrumbs() {
    return (this.props &&
            this.props.sectionTitle &&
            this.props.documentTitle &&
            this.props.documentPath) ? 
            <div>
              <Link to='/'>Home</Link>
              <span>&nbsp;/&nbsp;</span>
              <span>{this.props.sectionTitle}</span>
              <span>&nbsp;/&nbsp;</span>
              <span>{this.props.documentTitle}</span>
            </div> : <div />
  }

  render(){
    return (
      <div className="breadcrumbs">
        {this.setCrumbs()}
      </div>
    );
  }
}

export default Breadcrumb;
